import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';
import {
  GetActiveMultiApprovalRulesResponse,
  GetApprovalRulesResponse,
  GetChildApprovalRulesResponse,
  GetIsParentApprovalActiveRulesResponse,
  SubmitChildtMultiApprovalData,
  SubmitMultiApprovalData,
} from 'src/models';

export function getApprovalRules() {
  return axios.request<GetApprovalRulesResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/approval/v2/rules?is_parent=false`,
  });
}

export function getChildApprovalRules() {
  return axios.request<GetChildApprovalRulesResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/approval/v2/rules?is_parent=true`,
  });
}

export function setApprovalRules(data: SubmitMultiApprovalData[]) {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}/approval/v2/rules`,
    data,
  });
}

export function setChildApprovalRules(data: SubmitChildtMultiApprovalData) {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}/approval/v2/rules/children`,
    data,
  });
}

export function getIsParentApprovalActiveRules() {
  return axios.request<GetIsParentApprovalActiveRulesResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/approval/v2/rules/check-parent`,
  });
}

export function getActiveMultiApprovalRules() {
  return axios.request<GetActiveMultiApprovalRulesResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/approval/v2/rules/active`,
  });
}
